// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__S-U3d","footerBody":"Footer_footerBody__it1nS","footerLine":"Footer_footerLine__xS-Ew","footerLogo":"Footer_footerLogo__2avmX"};